module.exports = __webpack_public_path__ + "img/Thumbnails_Buying.ae7f998c.jpg";